module.exports = __webpack_public_path__ + "outline-icons.cd6c777f1945164224de.woff2";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/outline-icons.woff2
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/outline-icons.woff2
// module chunks = styles